<template>
  <div>
    <div v-if="active" class="modal is-active">
      <div class="modal-background"></div>
      <aside class="modal-card">
        <button @click="close" class="delete close-button" aria-label="close" qa="close-templates-modal"></button>
        <header class="title">
          <h2>{{ headerTitle }}</h2>
        </header>
        <section class="body">
          <form class="form">
            <div v-if="isJudging || isPublic">
              <div class="message-container">
                <i class="fas fa-clock"></i>
                <p>{{ message }}</p>
              </div>
            </div>
            <fieldset v-if="isOpen || isPublic" class="terms-of-use-checkboxes">
              <div class="checkbox-container is-flex">
                <label>
                  <input class="default-checkbox" type="checkbox" :value="hasCertified" v-model="hasCertified">
                  <span class="checkmark cursor-pointer"><i class="fal fa-check"></i></span>
                  <p>{{$t('ajasStart.iCertify' )}} {{ currentYear }}</p>
                </label>
                <div class="help is-danger" v-if="submitted &&!hasCertified">{{$t('ajasStart.required2')}}</div>
              </div>
              <div class="checkbox-container is-flex">
                <label>
                  <input class="default-checkbox" type="checkbox" :value="hasAgreed" v-model="hasAgreed">
                  <span class="checkmark cursor-pointer"><i class="fal fa-check"></i></span>
                  <p>{{$t('ajasStart.ownWork')}}</p>
                </label>
                <div class="help is-danger" v-if="submitted && !hasAgreed">{{$t('ajasStart.required2')}}</div>
              </div>
            </fieldset>
          </form>
        </section>
        <footer class="is-flex">
          <div class="button-container">
            <button class="button is-primary" @click="showCategoriesModal" :disabled="!hasAgreed || !hasCertified">{{$t('ajasStart.continue')}}</button>
          </div>
        </footer>
      </aside>
    </div>
    <categories-modal ref="categoryModal" :isCreate="true" @updateCategories="updateCategories" @forceClose="close"></categories-modal>
  </div>
</template>

<script>
import ModalCustom from '@/components/Modals/Custom'
import componentState from '@/mixins/component-state'
import closeOnEsc from '@/mixins/close-on-esc'
import setYear from '@/mixins/set-year'
import CategoriesModal from '@/components/Modals/Categories'
import i18n from '@/i18n'
import moment from 'moment-timezone'
import { releaseDate, releaseDateTimeZone, deadlineDate, deadlineTimeZone } from '@/mixins/ajas'

export default {
  components: {
    ModalCustom,
    CategoriesModal
  },
  mixins: [componentState, closeOnEsc, setYear],
  data: function () {
    return {
      hasCertified: false,
      hasAgreed: false,
      categories: [],
      submitted: false
    }
  },
  watch: {
    active: function () {
      if (this.active) {
        this._callback('lockScrolling')
      }
    }
  },
  computed: {
    active: function () {
      return this.$store.getters.modalIsVisible('startproject')
    },
    deadlineDate: function () {
      return moment.tz(deadlineDate, deadlineTimeZone)
    },
    projectsPublicDate: function () {
      return moment.tz(releaseDate, releaseDateTimeZone)
    },
    isOpen: function () {
      return moment().isBefore(this.deadlineDate)
    },
    isJudging: function () {
      return moment().isBefore(this.projectsPublicDate) && moment().isAfter(this.deadlineDate)
    },
    isPublic: function () {
      return moment().isAfter(this.projectsPublicDate)
    },
    headerTitle: function () {
      return this.isOpen ? i18n.t('ajasStart.required') : 'The deadline has passed!'
    },
    message: function () {
      if (this.isJudging) {
        return 'We are currently in the approval phase of the AJAS poster session and submissions have been locked. Please check back later.'
      } else if (this.isPublic) {
        return i18n.t('template.deadline')
      }
    }
  },
  methods: {
    close: function () {
      this._callback('unlockScrolling')
      this.$store.dispatch('hideStartProjectModal')
    },
    showCategoriesModal: function () {
      this.submitted = true
      this.$refs.categoryModal.showModal()
    },
    updateCategories: function (categories) {
      for (const category in categories) {
        this.categories.push(categories[category])
      }
      this.createProject(this.selectedTemplate)
    },
    createProject: function () {
      const query = { projectID: 38352, startButton: true, draft: true, private: true, hidden: true, category: this.categories }
      const path = '/start/template'
      this.$router.push({ path, query })
      this._callback('unlockScrolling')
      this.hasCertified = ''
      this.hasAgreed = ''
      this.categories = []
      this.submitted = false
      this.close()
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  $modal-body-color: #F2F2F2;
  $error-message-height: 24px;
  $close-icon-color: #1A051D;

  .modal-card {
    background: $modal-body-color;
    text-align: center;
    max-height: 730px;
    width: 70%;
    max-width: 620px;
    padding: 50px 60px;
    @include mobile {
    padding: 50px 10px;
    }
    // HEADER
    .title {
      font-size: 1rem;
      font-weight: 400;
      border-bottom: 1px solid #DCDCDC;
      h2 {
        font-family: $primary-font;
        font-weight: $primary-font-weight;
        padding: 1.3rem 0;
        text-align: left;
      }
    }
  }

  .body,
  footer {
    width: 70%;
    max-width: 350px;
    margin: 0 auto;
  }

  .body {
    padding: 1rem 0;
    font-size: 1.2rem;
  }

  .message-container {
    display: flex;
    align-items: center;
    background: white;
    padding: 1rem;
    margin-bottom: 1rem;
    i {
      font-size: 3rem;
      margin-right: 1.5rem;
      color: $primary;
    }
    p {
      font-size: 0.75rem;
      text-align: left;
    }
    @include mobile {
      flex-direction: column;
      i {
        margin-right: 0;
        margin-bottom: 1rem;
      }
    }
  }

  .is-flex {
    flex-direction: column;
  }

  .button-container {
    align-items: center;

    .button {
      flex: 0 0 auto;
      margin: 1rem 0 2.5rem;
      border-radius: 0;
      padding: 1.2rem 1.6rem;
      text-transform: uppercase;
      font-size: 0.9rem;
    }
  }

  // CUSTOM CHECKBOX STYLES
  .terms-of-use-checkboxes {
    padding-top: 0.5rem;
    text-align: left;
    position: relative;
    .disable-checkbox {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  // hiding the browser's default checkbox
  .default-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }
  .checkbox-container {
    flex-direction: column;
    position: relative;
    padding-left: 20px;
    padding-right: 10px;
    user-select: none;
    &:not(:nth-of-type(3)) {
      padding-bottom: 1rem;
    }
    @include mobile {
      padding-right: 0;
    }
    label {
      font-size: .8rem;
      display: inline;
      position: relative;
    }
    .checkbox-wrapper {
      padding: 10px 0;
      flex-wrap: wrap;
    }
    .checkmark {
      position: absolute;
      top: 2px;
      left: -30px;
      height: 20px;
      width: 20px;
      background-color: #FFFFFF;
      border: 1.5px solid #8b8b8b;
      transition: 0.1s;
      i {
        display: none;
        color: white;
        margin-left: 3px;
        margin-top: 2.1px;
      }
      &:hover {
        transition: 0.1s;
        background-color: #e9e9e9;
      }
      &:after {
        content: '';
        position: absolute;
        display: none;
      }
    }
    input:checked ~ .checkmark {
      i {
        display: block;
      }
      background-color: $primary;
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
  }
  .close-button {
    position: absolute;
    right: 1.5rem;
    top: 1.5rem;
  }
</style>
